<template>
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          @click="fetchWaybill"
          :disabled="isSee"
          v-if="editable && !feeCheckIn"
          >取出运单</el-button
        >
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          :disabled="isSee"
          v-if="editable && !feeCheckIn"
          @click="showFetchOneWaybill = true"
          >单票添加运单</el-button
        >
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          @click="removeWaybill"
          :disabled="isSee"
          v-if="editable && !feeCheckIn"
          >移除</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :maxHeight="300"
      :tableData="tableData_1"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      :isselection="editable && !feeCheckIn"
    >
      <template #transportPlanShow="{row}">
        <el-select v-model="row.transportPlan" @change="changeRow(row)" filterable>
          <el-option v-for="plan in transportPlans" :key="plan.planValue" :label="plan.planName" :value="plan.planValue"></el-option>
        </el-select>
      </template>
      <template #remarks="{row}">
        <el-input v-model="row.remarks" @change="changeRow(row)"></el-input>
      </template>
    </mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <myDialog
      diaWidth="1200px"
      dialogTitle="取出运单"
      :isShowDialog="showFetchWaybill"
      :showConfirm="true"
      @handleCloseDia="showFetchWaybill = false"
      @diaCancelBtn="showFetchWaybill = false"
      @diaConfirmBtn="handleCOnfirmWaybill"
    >
      <fetch-waybill :data="waybills" ref="waybillSelector" v-if="showFetchWaybill"></fetch-waybill>
    </myDialog>
    <my-dialog
    diaWidth="400px"
      dialogTitle="单票添加运单"
      :isShowDialog="showFetchOneWaybill"
      :showConfirm="true"
      @handleCloseDia="showFetchOneWaybill = false"
      @diaCancelBtn="showFetchOneWaybill = false"
      @diaConfirmBtn="handleCOnfirmOneWaybill"
    >
      <el-form :model="fetchOneWaybill" label-width="60px" label-position="right">
        <el-form-item label="运单号" prop="waybillNumber">
          <el-input v-model="fetchOneWaybill.waybillNumber"></el-input>
        </el-form-item>
      </el-form>
    </my-dialog>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
import FetchWaybill from "./FetchWaybill.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    sorttable,
    paging,
    mytable,
    myDialog,
    FetchWaybill,
  },
  props: {
    dispatchId: {},
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "edit",
    },
    op: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  data() {
    return {
      pageGroupName: "PickupDispatchCar123123", //  页面标识
      reportFiledsNumber: "admin_dispatch_detail_waybill_list_v5", // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "WaybillEdit", //当前页面的方法
          param: 1, //自定义参数标记
        },
        // {
        //   name: "删除",
        //   methods: "delBtns",
        //   param: "",
        // },
        {
          name: "详情",
          methods: "detail",
          param: 2,
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "修改运单号",
          command: "updateNumber",
        },
        {
          name: "修改基本信息",
          command: "updateInfo",
        },
      ],
      //需要单独点击的列字段名数组
      fieldList: ["commandNumber"],
      Operatewidth: "220px", //操作列的列宽
      showFetchWaybill: false,
      waybills: [],
      tableData_1: [],
      showFetchOneWaybill:false,
      fetchOneWaybill:{
        waybillNumber:''
      },
      transportPlans:[],
    };
  },
  computed:{
    editable() {
      return this.isSee != 1;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.op === "feeCheckIn";
    },
    baseEdit() {
      return this.op === "baseEdit";
    },
  },
  async mounted() {
    await this.getData({
      dispatchId: this.dispatchId,
    });
    this.tableData_1 = this.tableData.filter(
      (item) => item.operationType != "DEL"
    );
    this.getTransportPlans()
  },
  methods: {
    async getTransportPlans(){
      const res = await this.$API.runList({
        number:'transport_plan_list'
      })
      this.transportPlans = res
    },
    fetchWaybill() {
      this.waybills = this.tableData_1.map(item=>item.waybillSplitId)
      this.showFetchWaybill = true;
    },
    handleCOnfirmWaybill() {
      this.showFetchWaybill = false;
      const rows = this.$refs.waybillSelector.getRows();
      const ids = this.tableData.map((item) => item.waybillSplitId);
      rows.map((item) => {
        if (!ids.includes(item.waybillSplitId)) {
          this.tableData.push({
            ...item,
            waybillRemarks:item.remarks,
            remarks:'',
            operationType: "ADD",
            // 默认选中第一行方案
            transportPlan: 'ru_cang:transport_plan'
          });
        }
      });
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.$emit('calcAll')
    },
    async handleCOnfirmOneWaybill(){
      const res = await this.$API.runList({
        number:'admin_waybill_list_v5',
        waybillNumberNoLike:this.fetchOneWaybill.waybillNumber
      })
      if(!res || res.length == 0){
        this.$message.error("找不到运单")
        return
      }
      const ids = this.tableData.map((item) => item.waybillSplitId);
      res.map((item) => {
        if (!ids.includes(item.waybillSplitId)) {
          this.tableData.push({
            ...item,
            waybillRemarks:item.remarks,
            remarks:'',
            operationType: "ADD",
            // 默认选中第一行方案
            transportPlan: this.transportPlans[0] && this.transportPlans[0].planValue,
          });
        }
      });
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.showFetchOneWaybill = false
      this.fetchOneWaybill.waybillNumber = ''
      this.$emit('calcAll')
    },
    removeWaybill() {
      this.selectTableData.map((item) => {
        if(item.operationType === 'ADD'){
          item.operationType = 'REMOVE'
        }else{
          item.operationType = 'DEL'
        }
      });
      this.$refs.mytable.clearSelection();
      this.tableData = this.tableData.filter(item=>item.operationType !== 'REMOVE')
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.$emit('calcAll')
    },
    getRows() {
      return this.tableData.map((item, index) => {
        return {
          taskId:item.taskId,
          documentStatus: "bill_tms_waybill_split_v3:document_status",
          documentNumber: item.documentNumber,
          transportPlan: item.transportPlan,
          remarks: item.remarks,
          sort: index,
          operationType: item.operationType || 'UNCHANGED',
          packageCount:item.totalCount,
          totalGrossWeight:item.totalGrossWeight,
          totalVolume:item.totalVolume,
          
        };
      });
    },
    changeRow(row){
      if(row.operationType !=='ADD'){
        row.operationType = 'UPDATE'
      }
    }
  },
};
</script>

<style lang="less" scoped>
.glo_btnList {
  margin-bottom: 10px;
}
</style> 